import * as React from "react"
import {IconSeeker} from "@components/ui";


export default function MaximalLayoutHeaderchevronToolbar({ isOpen, sx }) {
	return <IconSeeker
		icon={isOpen ? "chevron-up" : "chevron-down"}
		iconWeight="thin"
		sx={{
			fontSize: 15,
			color: 'inherit',
			pl: .5,
			...sx
		}}
	/>
}